import { render, staticRenderFns } from "./Sign-up.vue?vue&type=template&id=f9704008"
import script from "./Sign-up.vue?vue&type=script&lang=ts"
export * from "./Sign-up.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports